import { render, staticRenderFns } from "./headerSouthern.vue?vue&type=template&id=fc8a4672&scoped=true"
import script from "./headerSouthern.vue?vue&type=script&lang=js"
export * from "./headerSouthern.vue?vue&type=script&lang=js"
import style0 from "./headerSouthern.vue?vue&type=style&index=0&id=fc8a4672&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8a4672",
  null
  
)

export default component.exports